import { Component, OnInit } from '@angular/core';
import { IconCardConfig } from 'src/app/interfaces/pageConfig';
import { ProductType } from 'src/app/interfaces/user';
import { AuthManagerService } from 'src/app/services/auth-manager/auth-manager.service';
import { CheckoutService } from 'src/app/services/checkout/checkout.service';
import { LogService } from 'src/app/services/common/log.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { MemberShipOptionsService } from 'src/app/services/membership-options/membership-options.service';
import { UserService } from 'src/app/services/user/user.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-identibase-plus-v2',
  templateUrl: './identibase-plus-v2.component.html',
  styleUrl: './identibase-plus-v2.component.scss'
})
export class IdentibasePlusV2Component implements OnInit {

  pricingPlans = environment.stripePlans;
  trustTitle: string;
  trustSubtitle: string;
  plan1ShowUpCards: IconCardConfig[];

  // True (enabled) until a signed-in user's current plan says otherwise.
  public identibasePlusAvailable = true;

  private isUpgrade: boolean;

    constructor(
    private configService: ConfigService,
    private authManager: AuthManagerService,
    private _checkoutService: CheckoutService,
    private _logService: LogService,
    private membershipOptionsService: MemberShipOptionsService,
    private userService: UserService,
  ) {

    this.plan1ShowUpCards = this.configService.getObjectListFromKey<IconCardConfig>('1-plan-showUpCards');
    this.trustTitle = this.configService.getTextFromKey('trust-title');
    this.trustSubtitle = this.configService.getTextFromKey('trust-subtitle');
  }

  ngOnInit(): void {
    if (!this.authManager.isAuthenticated) return;

    this.userService.getMe().subscribe((user) => {
      this.identibasePlusAvailable = this.membershipOptionsService.identiBasePlusAvailable(user);
      this.isUpgrade = user.productType === ProductType.Basic;
    });
  }

  public buyIdentibasePlusSubscription() {
    const planId = this.pricingPlans.identibasePlus;
    this._checkoutService.checkout([planId], { isUpgrade: this.isUpgrade }).subscribe({
      next: () => {
        // Nothing should happen here because if checkout gets completed successfully, a redirect
        // will be triggered by stripe checkout
      },
      error: (err) => {
        this._logService.error('an error occured: ', err);
      }
    });
  }

}
